import { render, staticRenderFns } from "./centre_hopitalier_list.vue?vue&type=template&id=c393a3f6&"
import script from "./centre_hopitalier_list.vue?vue&type=script&lang=js&"
export * from "./centre_hopitalier_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports